
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { FileText, Headphones } from "lucide-react";

interface SummaryProps {
  summary: {
    title: string;
    source: string;
    content: string;
    document_url: string;
    audio_summary?: boolean;
    date: string;
    tags: string[];
  };
}

const SummaryCard = ({ summary }: SummaryProps) => (
  <Card className="mb-4 overflow-hidden hover:shadow-md transition-shadow">
    <CardHeader className="pb-2">
      <div className="flex justify-between items-start">
        <div>
          <CardTitle className="text-lg text-foreground">{summary.title}</CardTitle>
          <CardDescription className="text-sm text-muted-foreground">{summary.source}</CardDescription>
        </div>
        <Badge variant="secondary" className="text-xs">
          <FileText size={14} className="mr-1" />
          Summary
        </Badge>
      </div>
    </CardHeader>
    <CardContent>
      <p className="text-foreground mb-4 text-sm">{summary.content}</p>
      <div className="flex justify-between items-center">
        <Button variant="outline" size="sm" asChild className="text-xs">
          <a href={summary.document_url} target="_blank" rel="noopener noreferrer">
            <FileText size={14} className="mr-1" />
            View Full Document
          </a>
        </Button>
        {summary.audio_summary && (
          <Button variant="outline" size="sm" className="text-xs">
            <Headphones size={14} className="mr-1" />
            Listen
          </Button>
        )}
      </div>
      <div className="flex flex-wrap gap-2 mt-4">
        {summary.tags.map((tag: string, i: number) => (
          <Badge key={i} variant="outline" className="text-xs">
            {tag}
          </Badge>
        ))}
      </div>
    </CardContent>
  </Card>
);

export default SummaryCard;
